import React from "react";
import { TileZhong, TileBamboo, TileDots, TileEast, TileWan } from "./TileMotif";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-cream-grain"
    >
      {/* Decorative corner tile */}
      <div
        aria-hidden="true"
        className="hidden md:block absolute -top-12 -right-16 opacity-[0.06] pointer-events-none select-none"
      >
        <TileZhong width={360} height={500} />
      </div>

      <div className="max-w-6xl mx-auto px-5 md:px-8 pt-12 md:pt-20 pb-16 md:pb-28 relative">
        {/* Eyebrow */}
        <div
          data-testid="hero-eyebrow"
          className="flex items-center gap-3 text-[11px] md:text-xs uppercase tracking-[0.25em] text-[#3D7A5A] mb-8 md:mb-10"
        >
          <span className="inline-block w-8 h-px bg-[#3D7A5A]" />
          Hong Kong Cantonese Mahjong · Powered by Claude AI
        </div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-14 items-center">
          {/* Left: headline + CTA */}
          <div className="md:col-span-7 text-center md:text-left">
            <h1
              data-testid="hero-headline"
              className="text-4xl sm:text-5xl md:text-6xl lg:text-[68px] leading-[1.02] tracking-tight text-[#1A1A1A]"
            >
              <span className="font-black">Master Mahjong</span>
              <br />
              <span className="font-light">with an</span>{" "}
              <span className="font-black">AI Coach</span>
              <br />
              <span className="font-light">in your corner.</span>
            </h1>

            <p
              data-testid="hero-subheadline"
              className="mt-6 md:mt-8 max-w-xl mx-auto md:mx-0 text-base md:text-lg text-[#3a3a38] leading-relaxed"
            >
              The first platform combining real Hong Kong Mahjong gameplay with
              Claude AI‑powered coaching, step‑by‑step courses, and a growing
              community.
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center md:items-start gap-4 sm:gap-5 justify-center md:justify-start">
              <button
                data-testid="hero-join-waitlist-btn"
                onClick={() => scrollTo("waitlist")}
                className="tile-shine bg-[#3D7A5A] text-[#F5F0E8] font-bold tracking-wide px-7 py-4 rounded-sm hover:bg-[#2E5C44] transition-colors text-sm md:text-base"
              >
                Join the Waitlist — It's Free
              </button>
              <button
                data-testid="hero-learn-more-btn"
                onClick={() => scrollTo("how")}
                className="text-[#1A1A1A] font-medium underline underline-offset-4 decoration-[#3D7A5A]/40 hover:decoration-[#3D7A5A] transition-colors text-sm md:text-base"
              >
                See how it works →
              </button>
            </div>

            <p className="mt-5 text-xs md:text-sm text-[#6b6a64]">
              Launching in 30 days. Be first in line.
            </p>
          </div>

          {/* Right: tile rack graphic */}
          <div className="md:col-span-5">
            <div
              data-testid="hero-tile-rack"
              className="relative mx-auto w-full max-w-[460px] h-[440px] sm:h-[500px]"
            >
              {/* Subtle red arc highlight — sits behind everything */}
              <div
                aria-hidden="true"
                className="absolute left-1/2 top-[44%] -translate-x-1/2 -translate-y-1/2 w-56 h-56 md:w-64 md:h-64 rounded-full border border-[#C0392B]/15 pointer-events-none"
              />

              {/* Back row — small, receded, spaced well clear of the center tile */}
              <div
                aria-hidden="true"
                className="absolute left-[4%] top-[6%] opacity-55"
              >
                <TileEast width={64} height={88} />
              </div>
              <div
                aria-hidden="true"
                className="absolute right-[4%] top-[2%] opacity-55"
              >
                <TileWan width={64} height={88} />
              </div>

              {/* Front row — a proper fan of three, flex-laid-out so they never overlap.
                  The center 中 tile is larger and rises slightly above the others. */}
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-center gap-6 sm:gap-8 px-2">
                <div className="animate-float-b -rotate-[4deg] origin-bottom translate-y-2">
                  <TileBamboo width={82} height={112} />
                </div>

                <div className="animate-float-a -translate-y-3 sm:-translate-y-5">
                  <TileZhong width={144} height={198} />
                </div>

                <div className="animate-float-b rotate-[4deg] origin-bottom translate-y-2">
                  <TileDots width={82} height={112} />
                </div>
              </div>

              {/* Felt table shadow sits above the arc but below the tiles */}
              <div
                aria-hidden="true"
                className="absolute left-[12%] right-[12%] bottom-[6px] h-6 rounded-[50%] bg-[#3D7A5A]/15 blur-md pointer-events-none"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
